export function getIsModifiersParam(paramsString) {
  const urlParams = new URLSearchParams(paramsString);
  const modifiersParam = urlParams.get('modifiers');
  return modifiersParam === 'true';
}
